import { useAuthState, useQuery } from '@based/sdk/react'
import { useBasedEndpoints } from '../providers/Endpoints/index.js'

type BasicUser = {
  id?: number
  name?: string
  email?: string
  role?: string
  picture?: string
  followMe: {
    location: string
    following: {
      id: number
      location: string
      color: string
    } & Record<string, any>
    followers: number[]
  } & Record<string, any>
} & Record<string, any>

export const useUsers = (): {
  me: BasicUser
  all: BasicUser[]
} => {
  const endpoints = useBasedEndpoints()
  const { token } = useAuthState()

  const { data = {} } = useQuery(
    token ? endpoints.users : '',
    { token },
    { persistent: true },
  )

  return data
}
